import { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

// The screen's current visit, for work that outlives the press that started
// it (#135). A save may finish after the person has moved on; the save
// itself stands, but its screen's next step, a read, a move to the next
// screen, a field focused or an error shown, belongs to the visit it was
// started in and must not reach whatever is on screen now.
//
// capture, called at the person's action, answers a function that says
// whether that visit is still the current one. A visit ends whenever the
// location changes, its path, its query or its history entry alike, and
// when the screen goes away. Coming back makes a new visit, even to the very
// same address or history entry, so a callback from the first one never
// counts as the second's.
//
// The address is checked as well: following a link changes it at once, while
// the router renders the new screen as a transition, so the screen being left
// can stay mounted, and its visit alive, for a moment after.
export function useVisit() {
  const { key, pathname, search } = useLocation();
  const current = useRef();

  useEffect(function() {
    const visit = { live: true };

    current.current = visit;

    return function() {
      visit.live = false;
    };
  }, [ key, pathname, search ]);

  return useCallback(function() {
    const visit = current.current;
    const address = window.location.href;

    return function() {
      return visit != null && visit.live === true && window.location.href === address;
    };
  }, []);
}
